import { useState, useEffect } from 'react'
import useNotifications from '../useNotifications'
import { getAttachedArtifacts } from '../../services/artifactService'

/**
 * A hook to get artifacts attached to a tree person
 * @param {Object} options, with personId, artifactCategory, paginatorCount and firstRecordIndex
 * @returns {Object} object with loading boolean, error status/data, page count, totalArtifactsSpanningPages, and artifacts array
 */
const useAttachedArtifacts = ({ personId, artifactCategory, paginatorCount, firstRecord }) => {
  const { error } = useNotifications()
  const [artifacts, setArtifacts] = useState()
  const [totalArtifactsSpanningPages, setTotalArtifactsSpanningPages] = useState()

  useEffect(() => {
    const fetchData = async () => {
      getAttachedArtifacts(personId, artifactCategory, firstRecord, paginatorCount)
        .then((response) => {
          setArtifacts(response.data.artifact)
          setTotalArtifactsSpanningPages(response.data.totalArtifactsSpanningPages)
        })
        .catch((err) => {
          error(`Error fetching person memories: ${err.message || ''}`, err)
          setArtifacts([])
        })
    }
    fetchData()
  }, [artifactCategory, personId, paginatorCount, firstRecord, error])

  return {
    artifacts,
    totalArtifactsSpanningPages,
  }
}

export default useAttachedArtifacts
